import React from "react";

// Components
import Cookies from "universal-cookie";
import getCorso from "../../services/getCorso";
import getStudenti from "../../services/getStudenti";
import getLezioniSvolte from "../../services/getLezioniSvolte";
import getPresenzeCorso from "../../services/getPresenzeCorso";
import getLezioneRecuperata from "../../services/getLezioneRecuperata";
import getSessioniLezione from "../../services/getSessioniLezione";
import getCambioCorsoStudente from "../../services/getCambioCorsoStudente";
import getRecuperi from "../../services/getRecuperi";
import getPresenzeStudente from "../../services/getPresenzeStudente";
import getMaterie from "../../services/getMaterie";
import moment from "moment";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

export default class PdfRiepilogoPresenze extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dettagliPresenze: [],
      totaleLezioniFull: 0, // Totale lezioni (presenze + assenze)
      isLoading: true,
      isReadyToShow: false,
    };

    this.sessioniMap = {};
    this.materieMap = {};
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCorso = cookies.get("currentCourse", { path: "/" });
    const studentID = cookies.get("currentStudente", { path: "/" });

    // Carica elenco materie per risolvere i nomi anche quando non arrivano dal backend
    try {
      this.materie = await getMaterie(username, token);
      if (Array.isArray(this.materie)) {
        this.materieMap = this.materie.reduce((acc, materia) => {
          const idMateria =
            materia?.id ?? materia?.id_materia ?? materia?.ID ?? null;
          const nomeMateria =
            materia?.materia ||
            materia?.nome ||
            materia?.nome_materia ||
            materia?.descrizione ||
            "";

          if (
            idMateria !== null &&
            idMateria !== undefined &&
            nomeMateria &&
            nomeMateria.trim() !== ""
          ) {
            acc[idMateria.toString()] = nomeMateria.trim();
          }
          return acc;
        }, {});
        console.log(
          `[PDF] 🧭 Materie caricate: ${Object.keys(this.materieMap).length}`,
        );
      } else {
        this.materieMap = {};
      }
    } catch (error) {
      console.error("[PDF] Errore caricamento materie:", error);
      this.materieMap = {};
    }

    // Inizializza sessioniMap per compatibilità con il rendering
    this.sessioniMap = {};

    this.corso = await getCorso(username, token, currentCorso);
    this.studenti = await getStudenti(username, token);
    this.studente = this.studenti.find((s) => s.id == studentID);
    this.lezioniSvolte = await getLezioniSvolte(username, token, currentCorso);

    // 🆕 USA IL NUOVO SISTEMA UNIFICATO
    console.log("[PDF] 🆕 Caricamento presenze unificate...");
    const presenzeUnificate = await getPresenzeStudente(
      username,
      token,
      studentID,
      currentCorso,
    );

    console.log(
      `[PDF] ✅ Caricate ${presenzeUnificate.length} presenze unificate (corso corrente + precedenti)`,
    );

    // 🆕 Popola sessioniMap dai dati unificati
    presenzeUnificate.forEach((p) => {
      if (
        p.id_sessione &&
        p.sessione_ordine !== undefined &&
        p.sessione_ordine !== null
      ) {
        this.sessioniMap[p.id_sessione] = {
          id: p.id_sessione,
          ordine: p.sessione_ordine,
        };
      }
    });

    console.log(
      `[PDF] 🗺️ sessioniMap popolata con ${
        Object.keys(this.sessioniMap).length
      } sessioni`,
    );

    // Separa presenze corso corrente e corsi precedenti
    const presenzeCorsoCorrente = presenzeUnificate.filter(
      (p) => p.id_corso == currentCorso,
    );
    const presenzePrecedenti = presenzeUnificate.filter(
      (p) => p.id_corso != currentCorso,
    );

    /* ========== VECCHIO CODICE - COMMENTATO ==========
    // Carica le sessioni per tutte le lezioni con presenze divise
    console.log("[PDF] Caricamento sessioni per le lezioni...");
    this.sessioniMap = {}; // Mappa id_sessione -> oggetto sessione
    this.lezioniConSessioniSet = new Set(); // Traccia quali lezioni hanno sessioni

    // === CARICA SESSIONI PER TUTTE LE LEZIONI DEL CORSO ===
    // Non solo quelle con presenze registrate, ma TUTTE le lezioni
    // Questo è necessario per calcolare correttamente il peso delle assenze
    // anche quando lo studente è assente senza record di presenza
    console.log(
      `[PDF] Caricamento sessioni per ${this.lezioniSvolte.length} lezioni del corso...`
    );

    for (const lezione of this.lezioniSvolte) {
      try {
        const sessioni = await getSessioniLezione(username, token, lezione.id);
        if (sessioni && sessioni.length > 0) {
          sessioni.forEach((sessione) => {
            this.sessioniMap[sessione.id] = sessione;
          });
          this.lezioniConSessioniSet.add(lezione.id); // Marca che questa lezione ha sessioni
          console.log(
            `[PDF] Lezione ${lezione.id}: ${sessioni.length} sessioni caricate`
          );
        }
      } catch (error) {
        console.error(
          `[PDF] Errore caricamento sessioni lezione ${lezione.id}:`,
          error
        );
      }
    }

    console.log(
      `[PDF] Totale sessioni caricate (corso corrente): ${
        Object.keys(this.sessioniMap).length
      }`
    );

    // === CARICA ASSENZE PRECEDENTI DA ALTRI CORSI ===
    console.log("[PDF] Caricamento assenze precedenti da corsi precedenti...");
    let assenzePrecedenti = [];
    let numAssenzePrecedenti = 0;

    try {
      const corsiData = await getCambioCorsoStudente(
        username,
        token,
        currentCorso
      );

      // Trova lo studente nei dati di cambio corso
      const studenteCambioCorso = corsiData.find(
        (item) => item.id_studente == studentID
      );

      if (
        studenteCambioCorso &&
        studenteCambioCorso.info_corso_precedente &&
        studenteCambioCorso.info_corso_precedente.assenze_corso_precedente &&
        Array.isArray(
          studenteCambioCorso.info_corso_precedente.assenze_corso_precedente
        )
      ) {
        const assenzeGrezze =
          studenteCambioCorso.info_corso_precedente.assenze_corso_precedente;

        // Filtra solo assenze non recuperate (presenza != 1)
        const assenzeNonRecuperate = assenzeGrezze.filter(
          (a) => a.presenza != 1
        );

        // === CARICA SESSIONI PER LE LEZIONI DEI CORSI PRECEDENTI ===
        const lezioniPrecedentiConSessioni = new Set(
          assenzeNonRecuperate
            .filter(
              (a) =>
                a.id_sessione &&
                a.id_sessione !== null &&
                a.id_sessione !== "null" &&
                a.id_sessione !== ""
            )
            .map((a) => a.id_lezione)
        );

        console.log(
          `[PDF] Caricamento sessioni per ${lezioniPrecedentiConSessioni.size} lezioni dei corsi precedenti...`
        );

        for (const idLezione of lezioniPrecedentiConSessioni) {
          try {
            const sessioni = await getSessioniLezione(
              username,
              token,
              idLezione
            );
            sessioni.forEach((sessione) => {
              this.sessioniMap[sessione.id] = sessione;
            });
            console.log(
              `[PDF] Lezione precedente ${idLezione}: ${sessioni.length} sessioni caricate`
            );
          } catch (error) {
            console.error(
              `[PDF] Errore caricamento sessioni lezione precedente ${idLezione}:`,
              error
            );
          }
        }

        console.log(
          `[PDF] Totale sessioni caricate (con corsi precedenti): ${
            Object.keys(this.sessioniMap).length
          }`
        );

        // === CARICA RECUPERI CROSS-CORSO PER VERIFICARE STATUS ===
        console.log("[PDF] Caricamento recuperi cross-corso...");
        let recuperiCrossCorso = [];
        try {
          const recuperiData = await getRecuperi(username, token);
          // Gestisci struttura risposta come in EditCorso
          const tuttiRecuperi = Array.isArray(recuperiData)
            ? recuperiData
            : recuperiData?.data || recuperiData?.recuperi || [];
          // Filtra solo recuperi per questo studente
          recuperiCrossCorso = tuttiRecuperi.filter(
            (r) => r.id_studente == studentID
          );
          
          // ✅ NUOVO: Aggiungi anche i recuperi precedenti dal JSON info_corso_precedente
          if (
            studenteCambioCorso.info_corso_precedente.recuperi_corso_precedente &&
            Array.isArray(studenteCambioCorso.info_corso_precedente.recuperi_corso_precedente)
          ) {
            const recuperiPrecedenti = studenteCambioCorso.info_corso_precedente.recuperi_corso_precedente;
            console.log(
              `[PDF] 🔄 Trovati ${recuperiPrecedenti.length} recuperi nel JSON info_corso_precedente`
            );
            // Combina recuperi da backend + recuperi da JSON
            recuperiCrossCorso = [...recuperiCrossCorso, ...recuperiPrecedenti];
            console.log(
              `[PDF] Totale recuperi combinati: ${recuperiCrossCorso.length}`
            );
          }
          
          console.log(
            `[PDF] Caricati ${recuperiCrossCorso.length} recuperi totali per studente ${studentID} (corso corrente + precedenti)`
          );
        } catch (error) {
          console.error("[PDF] Errore caricamento recuperi:", error);
        }

        // Converti nel formato dettagliPresenze
        assenzePrecedenti = assenzeNonRecuperate.map((assenza) => {
          const hasSessione =
            assenza.id_sessione &&
            assenza.id_sessione !== null &&
            assenza.id_sessione !== "null" &&
            assenza.id_sessione !== "";
          const peso = hasSessione ? 0.5 : 1.0;

          // === VERIFICA SE ASSENZA È STATA RECUPERATA ===
          let idRecuperoLezioni = null;
          let statusAssenza = "ASSENTE";
          let dataRecupero = null;
          let noteRecupero = null;

          // Cerca recupero cross-corso che matcha questa assenza
          // Usa id_assenza_originale come nel modal EditCorso
          const recuperoMatch = recuperiCrossCorso.find((r) => {
            const lezioneMatch = r.id_assenza_originale == assenza.id_lezione;
            
            // ✅ FIX: Usa id_sessione_assenza per recuperi da JSON, id_sessione per recuperi da backend
            const sessioneRecupero = r.id_sessione_assenza || r.id_sessione;
            const sessioneMatch =
              (sessioneRecupero == null && assenza.id_sessione == null) ||
              sessioneRecupero == assenza.id_sessione;

            if (lezioneMatch && sessioneMatch) {
              console.log(
                `[PDF] Match trovato! Recupero ${r.id}: lezione ${assenza.id_lezione}, sessione ${assenza.id_sessione}, status: ${r.status || 'N/A'}`
              );
            }

            return lezioneMatch && sessioneMatch;
          });

          if (recuperoMatch) {
            // ✅ FIX: Gestisci sia status dal JSON che verifica id_lezione_recupero
            const statusRecupero = recuperoMatch.status; // Status dal backend JSON (COMPLETATO, RICHIESTA, etc.)
            const idLezioneRecupero =
              recuperoMatch.id_lezione_recupero ||
              recuperoMatch.id_recupero ||
              recuperoMatch.idLezioneRecupero ||
              recuperoMatch.idRecupero;

            // Verifica esplicita che sia un valore valido (non null, undefined, 0, o stringa vuota)
            const isCompletato =
              statusRecupero === 'COMPLETATO' ||
              (idLezioneRecupero !== null &&
              idLezioneRecupero !== undefined &&
              idLezioneRecupero !== "" &&
              idLezioneRecupero !== 0 &&
              idLezioneRecupero !== "0");

            console.log(
              `[PDF] Recupero ${recuperoMatch.id} - status: ${statusRecupero}, id_lezione_recupero: ${recuperoMatch.id_lezione_recupero}, isCompletato: ${isCompletato}`
            );

            if (isCompletato) {
              // Recupero COMPLETATO
              idRecuperoLezioni = recuperoMatch.id;
              // Cerca la data del recupero (come nel modal)
              dataRecupero =
                recuperoMatch.data_recupero ||
                recuperoMatch.data ||
                recuperoMatch.data_lezione_recupero;
              noteRecupero =
                recuperoMatch.note || recuperoMatch.note_recupero || null;
              statusAssenza = "RECUPERATO";
              console.log(
                `[PDF] ✅ Assenza precedente ${assenza.id_lezione}/${assenza.id_sessione} COMPLETAMENTE RECUPERATA con id ${idRecuperoLezioni}, data: ${dataRecupero}`
              );
            } else {
              // ✅ NUOVO: Recupero RICHIESTO ma NON completato - mostra come IN RICHIESTA
              idRecuperoLezioni = recuperoMatch.id;
              statusAssenza = "IN RICHIESTA";
              dataRecupero = recuperoMatch.data_richiesta || null;
              noteRecupero = recuperoMatch.note || null;
              console.log(
                `[PDF] ⏳ Assenza precedente ${assenza.id_lezione}/${assenza.id_sessione} ha recupero IN RICHIESTA (id ${recuperoMatch.id})`
              );
            }
          }

          // Formatta la data per display leggibile
          // Usa gli stessi campi del modal EditCorso
          const dataRaw =
            assenza.assenza || assenza.data || assenza.data_lezione;
          const dataFormatted = dataRaw
            ? new Date(dataRaw.replace(" ", "T")).toLocaleString("it-IT", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "Data non disponibile";

          // Debug data
          console.log(
            `[PDF] Assenza ${assenza.id_lezione}: data raw="${dataRaw}", formatted="${dataFormatted}"`
          );

          // Migliora visualizzazione argomento con nome corso e data
          const nomeCorso =
            studenteCambioCorso.info_corso_precedente?.nome_corso_precedente ||
            "Corso precedente";

          // Usa gli stessi campi argomento del modal
          const argomentoRaw = assenza.argomento || assenza.materia;

          // Debug: log per verificare struttura dati
          if (
            !studenteCambioCorso.info_corso_precedente?.nome_corso_precedente
          ) {
            console.log(
              "[PDF] ⚠️ Nome corso precedente mancante. Struttura disponibile:",
              Object.keys(studenteCambioCorso.info_corso_precedente || {})
            );
            console.log(
              "[PDF] Dati completi corso precedente:",
              studenteCambioCorso.info_corso_precedente
            );
          }

          const argomentoDisplay =
            argomentoRaw && argomentoRaw.trim() !== ""
              ? argomentoRaw
              : `${nomeCorso} (${dataFormatted})`;

          return {
            data: dataRaw, // Usa la data raw per il campo data (per formattazione nel PDF)
            argomento: argomentoDisplay,
            durata: null,
            status: statusAssenza,
            recupero: idRecuperoLezioni
              ? `Recupero #${idRecuperoLezioni}`
              : null,
            id_recupero: idRecuperoLezioni,
            data_recupero: dataRecupero, // ✅ Aggiunto: data del recupero
            note_recupero: noteRecupero, // ✅ Aggiunto: note del recupero
            id_sessione: assenza.id_sessione,
            peso: peso,
            isDaCorsoPrecedente: true, // Flag per distinguerle
          };
        });

        // Calcola assenze precedenti NON recuperate per il conteggio
        numAssenzePrecedenti = assenzePrecedenti
          .filter((a) => !a.status.includes("RECUPERATO"))
          .reduce((sum, a) => sum + a.peso, 0);

        console.log(
          `[PDF] ✅ Trovate ${assenzePrecedenti.length} assenze precedenti (totale non recuperate: ${numAssenzePrecedenti})`
        );
      } else {
        console.log("[PDF] Nessuna assenza precedente trovata per lo studente");
      }
    } catch (error) {
      console.error("[PDF] Errore caricamento assenze precedenti:", error);
    }

    // Otteniamo i dettagli delle presenze dello studente, proprio come nel modal
    const dettagliPresenze = [];

    // Ordiniamo le lezioni per data
    this.lezioniSvolte.sort((l1, l2) => {
      const data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
      const data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
      return data1 < data2 ? -1 : 1;
    });

    // Mappa per i recuperi confermati
    const lezioniRecuperateMap = {};

    for (const l of this.lezioniSvolte) {
      const presenze = this.presenzeCorso.filter(
        (p) => p.id_lezione == l.id && p.id_studente == studentID
      );

      // Se non ci sono presenze registrate, salta questa lezione
      // (non creare assenze automatiche per lezioni senza presenze)
      if (presenze.length == 0) {
        continue; // Vai alla prossima lezione
      } else {
        // Se ci sono presenze, creiamo UNA RIGA PER OGNI SESSIONE
        // Questo gestisce il caso di assenza mattina E pomeriggio come DUE righe separate
        for (const presenza of presenze) {
          const val = presenza.presenza == -1 ? "ASSENTE" : "PRESENTE";

          // Calcola il peso: 0.5 per sessioni (mezza giornata), 1.0 per lezione intera
          const hasSessione =
            presenza.id_sessione &&
            presenza.id_sessione !== null &&
            presenza.id_sessione !== "null" &&
            presenza.id_sessione !== "";
          const peso = hasSessione ? 0.5 : 1.0;

          const dettaglio = {
            data: l.data,
            argomento: l.argomento || "",
            durata: l.durata,
            status: val,
            recupero: null,
            id_recupero: presenza.id_recupero_lezioni,
            id_sessione: presenza.id_sessione,
            peso: peso,
          };

          if (presenza.ore != "") {
            dettaglio.argomento += " " + presenza.ore + "/" + l.durata / 60;
          }

          // Verifica se c'è un recupero confermato per le assenze
          if (dettaglio.status === "ASSENTE" && dettaglio.id_recupero) {
            try {
              const recuperoInfo = await getLezioneRecuperata(
                username,
                token,
                dettaglio.id_recupero
              );

              // ✅ FIX: Verifica che il recupero sia COMPLETATO controllando id_lezione_recupero
              const idLezioneRecupero =
                recuperoInfo?.id_lezione_recupero ||
                recuperoInfo?.id_recupero ||
                recuperoInfo?.idLezioneRecupero ||
                recuperoInfo?.idRecupero;

              // Verifica esplicita che sia un valore valido (non null, undefined, 0, o stringa vuota)
              const isCompletato =
                idLezioneRecupero !== null &&
                idLezioneRecupero !== undefined &&
                idLezioneRecupero !== "" &&
                idLezioneRecupero !== 0 &&
                idLezioneRecupero !== "0";

              console.log(
                `[PDF] Recupero ID ${dettaglio.id_recupero} - id_lezione_recupero: ${recuperoInfo?.id_lezione_recupero}, isCompletato: ${isCompletato}`
              );

              if (
                recuperoInfo &&
                recuperoInfo.result === "ok" &&
                isCompletato
              ) {
                // Determina il peso del recupero
                const hasSessioneRecupero =
                  recuperoInfo.id_sessione &&
                  recuperoInfo.id_sessione !== null &&
                  recuperoInfo.id_sessione !== "null" &&
                  recuperoInfo.id_sessione !== "";
                const pesoRecupero = hasSessioneRecupero ? 0.5 : 1.0;

                dettaglio.recupero = {
                  data: recuperoInfo.data || recuperoInfo.data_recupero,
                  confermato: true,
                  peso: pesoRecupero,
                  id_sessione: recuperoInfo.id_sessione,
                };

                // Cambia lo status da ASSENTE a RECUPERATO solo se il recupero è COMPLETATO
                dettaglio.status = "RECUPERATO";
                dettaglio.data_recupero = recuperoInfo.data || recuperoInfo.data_recupero;
                console.log(
                  `[PDF] ✓ Recupero ID ${dettaglio.id_recupero} COMPLETATO per lezione ${l.id}`
                );
              } else if (recuperoInfo && recuperoInfo.result === "ok") {
                // Recupero richiesto ma NON completato - segna come IN RICHIESTA
                dettaglio.status = "ASSENTE - IN RICHIESTA";
                dettaglio.data_richiesta = recuperoInfo.created_at || recuperoInfo.data;
                dettaglio.note_richiesta = recuperoInfo.note || "";
                console.log(
                  `[PDF] ⚠️ Recupero ID ${dettaglio.id_recupero} IN RICHIESTA per lezione ${l.id}`
                );
              }
            } catch (error) {
              console.error(
                "Errore nel recupero delle informazioni di recupero:",
                error
              );
            }
          }

          dettagliPresenze.push(dettaglio);
        }
      }
    }

    // === AGGIUNGI ASSENZE PRECEDENTI ALLA LISTA ===
    // Ordina le assenze precedenti per data
    if (assenzePrecedenti.length > 0) {
      assenzePrecedenti.sort((a, b) => {
        const dataA = moment(a.data, "yyyy-MM-DD HH:mm:ss");
        const dataB = moment(b.data, "yyyy-MM-DD HH:mm:ss");
        return dataA < dataB ? -1 : 1;
      });

      // Inserisci le assenze precedenti all'inizio della lista
      dettagliPresenze.unshift(...assenzePrecedenti);

      console.log(
        `[PDF] ✅ Totale presenze/assenze (incluse precedenti): ${dettagliPresenze.length}`
      );
    }
    ========== FINE VECCHIO CODICE COMMENTATO ========== */

    // 🆕 COSTRUISCI DETTAGLI CON IL NUOVO SISTEMA
    const dettagliPresenze = [];
    let totaleLezioniFull = 0; // Contatore per TUTTE le lezioni (presenze + assenze)

    for (const presenza of presenzeUnificate) {
      const status = presenza.presenza == -1 ? "ASSENTE" : "PRESENTE";
      const hasSessione = presenza.id_sessione && presenza.id_sessione !== null;
      const peso = hasSessione ? 0.5 : 1.0;

      // Conta tutte le lezioni (sia presenze che assenze) per il totale
      totaleLezioniFull += peso;

      let statusFinal = status;
      if (status === "ASSENTE") {
        if (
          presenza.id_lezione_recupero &&
          presenza.id_lezione_recupero !== 0
        ) {
          statusFinal = "RECUPERATO";
        } else if (
          presenza.id_richiesta_recupero &&
          presenza.id_richiesta_recupero !== 0
        ) {
          // ✅ MODIFICA 3: Distingui tra programmato e in richiesta
          // stato_proposta: 0 = in attesa, 1 = accettato, 2 = rifiutato
          if (
            presenza.stato_proposta === 1 ||
            presenza.stato_proposta === "1"
          ) {
            statusFinal = "ASSENTE - PROGRAMMATO";
          } else {
            statusFinal = "ASSENTE - IN RICHIESTA";
          }
        }
      }

      // ✅ MODIFICA 1: Escludi le presenze (presenza=1) dal PDF
      // Mostra solo assenze, recuperi e richieste
      if (status === "PRESENTE") {
        continue; // Salta le presenze, non aggiungerle al PDF
      }

      const argomentoCompleto = this.buildArgomentoCompleto(
        presenza,
        currentCorso,
      );

      // 🐛 DEBUG: Log per capire perché data_proposta manca per le sessioni
      if (statusFinal === "ASSENTE - PROGRAMMATO" && hasSessione) {
        console.log("[PDF DEBUG PROGRAMMATO SESSIONE]", {
          id_lezione: presenza.id_lezione,
          id_sessione: presenza.id_sessione,
          id_richiesta_recupero: presenza.id_richiesta_recupero,
          stato_proposta: presenza.stato_proposta,
          data_proposta: presenza.data_proposta,
          id_lezione_proposta: presenza.id_lezione_proposta,
        });
      }

      dettagliPresenze.push({
        data: presenza.data_lezione,
        argomento: argomentoCompleto,
        durata: presenza.durata,
        status: statusFinal,
        id_sessione: presenza.id_sessione,
        peso: peso,
        isDaCorsoPrecedente: presenza.id_corso != currentCorso,
        recupero: presenza.id_lezione_recupero
          ? {
              data: presenza.data_recupero,
              confermato: true,
              peso: peso,
            }
          : null,
        data_recupero: presenza.data_recupero,
        data_richiesta: presenza.data_creazione_richiesta,
        // ✅ NUOVO: Dati proposta recupero per mostrare data programmata
        data_proposta: presenza.data_proposta,
        id_lezione_proposta: presenza.id_lezione_proposta,
        stato_proposta: presenza.stato_proposta,
      });
    }

    const numAssenzePrecedenti = dettagliPresenze
      .filter((d) => d.isDaCorsoPrecedente && !d.status.includes("RECUPERATO"))
      .reduce((sum, d) => sum + d.peso, 0);

    console.log(
      `[PDF] ✅ Costruiti ${dettagliPresenze.length} dettagli (${numAssenzePrecedenti} assenze precedenti), Totale lezioni: ${totaleLezioniFull}`,
    );

    this.setState({
      dettagliPresenze,
      numAssenzePrecedenti, // Salva per le statistiche
      totaleLezioniFull, // Totale lezioni (presenze + assenze)
      isLoading: false,
      isReadyToShow: true,
    });
  }

  /**
   * Sanitizza una stringa rimuovendo caratteri anomali all'inizio
   * come &, # o altri simboli non voluti che potrebbero derivare
   * da errori di inserimento dati nel database
   */
  sanitizeText(text) {
    if (!text || typeof text !== "string") return "";
    let sanitized = text.trim();
    // Rimuove & o # all'inizio della stringa (anche ripetuti)
    // La regex rimuove & all'inizio SOLO se:
    // - NON è seguito da un'entità HTML valida (es: &amp; &lt; &gt; &quot; &nbsp;)
    // Gestisce anche lettere maiuscole come &MEZZA
    sanitized = sanitized.replace(
      /^&(?!(amp|lt|gt|quot|nbsp|apos|#\d+);)/gi,
      "",
    );
    // Ripeti nel caso ci siano più & consecutivi
    while (
      sanitized.startsWith("&") &&
      !sanitized.match(/^&(amp|lt|gt|quot|nbsp|apos|#\d+);/i)
    ) {
      sanitized = sanitized.substring(1).trim();
    }
    // Rimuove eventuali spazi iniziali rimasti dopo la sanitizzazione
    return sanitized.trim();
  }

  resolveMateriaName(presenza) {
    const nomeDiretto =
      presenza?.nome_materia ||
      presenza?.materia ||
      presenza?.descrizione_materia ||
      "";

    if (nomeDiretto && nomeDiretto.trim() !== "") {
      return this.sanitizeText(nomeDiretto);
    }

    if (
      presenza?.id_materia !== undefined &&
      presenza?.id_materia !== null &&
      this.materieMap
    ) {
      const key = presenza.id_materia.toString();
      if (this.materieMap[key]) {
        return this.sanitizeText(this.materieMap[key]);
      }
    }

    return "";
  }

  buildArgomentoCompleto(presenza, currentCorso) {
    const parti = [];
    const nomeCorso =
      presenza?.nome_corso ||
      (presenza?.id_corso == currentCorso
        ? this.corso?.name || this.corso?.nome
        : null);

    if (nomeCorso && nomeCorso.trim() !== "") {
      parti.push(this.sanitizeText(nomeCorso));
    }

    let descrizionePrincipale =
      presenza?.argomento && presenza.argomento.trim() !== ""
        ? this.sanitizeText(presenza.argomento)
        : "";

    const nomeMateria = this.resolveMateriaName(presenza);
    if (nomeMateria) {
      descrizionePrincipale = descrizionePrincipale
        ? `${descrizionePrincipale} (${nomeMateria})`
        : nomeMateria;
    }

    if (descrizionePrincipale) {
      parti.push(descrizionePrincipale);
    }

    if (parti.length === 0) {
      const dataLabel = presenza?.data_lezione
        ? moment(presenza.data_lezione).format("DD/MM/YYYY HH:mm")
        : null;
      parti.push(
        dataLabel
          ? `Lezione del ${dataLabel}`
          : `Lezione ${presenza?.id_lezione || ""}`,
      );
    }

    return parti.join(" - ");
  }

  formatDate(dateString) {
    if (!dateString) return "";
    return moment(dateString).format("DD/MM/YYYY");
  }

  // Determina se una sessione è Prima metà o Seconda metà in base all'id_sessione
  getSessioneLabel(idSessione) {
    if (!idSessione || idSessione === "null" || idSessione === "") {
      return null; // Giornata intera
    }

    const sessione = this.sessioniMap[idSessione];
    if (!sessione) {
      return "Sessione"; // Fallback se la sessione non è trovata
    }

    // sessione_ordine: 1 => Prima metà (mattina), 2 => Seconda metà (pomeriggio)
    return sessione.ordine === 1 ? "Prima metà" : "Seconda metà";
  }

  render() {
    if (!this.state.isReadyToShow) {
      return <div>Caricamento...</div>;
    }

    const studenteNome = this.studente
      ? `${this.studente.cognome} ${this.studente.nome}`
      : "Studente non trovato";
    const corsoNome = this.corso ? this.corso.name : "Corso non trovato";

    // Calcolo statistiche con peso (mezze giornate e giornate intere)
    // Usa totaleLezioniFull che include sia presenze che assenze
    const totaleLezrioni = this.state.totaleLezioniFull || 0;

    // Calcola presenze (somma dei pesi)
    const presenzePeso = this.state.dettagliPresenze
      .filter((d) => d.status === "PRESENTE")
      .reduce((sum, d) => sum + d.peso, 0);

    // Conta presenze mezze giornate e giornate intere
    const presenzeIntere = this.state.dettagliPresenze.filter(
      (d) => d.status === "PRESENTE" && d.peso === 1.0,
    ).length;
    const presenzeMezzeGiornate = this.state.dettagliPresenze.filter(
      (d) => d.status === "PRESENTE" && d.peso === 0.5,
    ).length;

    // Calcola assenze totali (somma dei pesi) - INCLUDI TUTTE, anche quelle recuperate
    const tutteLeAssenze = this.state.dettagliPresenze.filter(
      (d) => d.status.includes("ASSENTE") || d.status.includes("RECUPERATO"),
    );

    console.log("[PDF] 🔍 DEBUG TUTTE LE ASSENZE (incluse recuperate):");
    tutteLeAssenze.forEach((a, idx) => {
      console.log(
        `  ${idx + 1}. Data: ${a.data}, Sessione: ${a.id_sessione}, Peso: ${
          a.peso
        }, Status: ${a.status}, Argomento: ${a.argomento?.substring(0, 50)}`,
      );
    });

    const assenzeTotaliPeso = tutteLeAssenze.reduce(
      (sum, d) => sum + d.peso,
      0,
    );

    console.log(
      `[PDF] 🔍 TOTALE ASSENZE PESO: ${assenzeTotaliPeso} (da ${tutteLeAssenze.length} righe)`,
    );

    // Separa assenze correnti e precedenti - INCLUDI TUTTE (anche recuperate)
    const assenzeCorsoCorrente = this.state.dettagliPresenze.filter(
      (d) =>
        (d.status.includes("ASSENTE") || d.status.includes("RECUPERATO")) &&
        !d.isDaCorsoPrecedente,
    );
    const assenzeCorsoPrecedente = this.state.dettagliPresenze.filter(
      (d) =>
        (d.status.includes("ASSENTE") || d.status.includes("RECUPERATO")) &&
        d.isDaCorsoPrecedente,
    );

    const assenzeCorsoCorrentePeso = assenzeCorsoCorrente.reduce(
      (sum, d) => sum + d.peso,
      0,
    );
    const assenzeCorsoPrecedentePeso = assenzeCorsoPrecedente.reduce(
      (sum, d) => sum + d.peso,
      0,
    );

    // Conta mezze giornate e giornate intere separate (corso corrente)
    const assenzeIntere = assenzeCorsoCorrente.filter((d) => d.peso === 1.0)
      .length;
    const assenzeMezzeGiornate = assenzeCorsoCorrente.filter(
      (d) => d.peso === 0.5,
    ).length;

    // Conta mezze giornate e giornate intere (corso precedente)
    const assenzeInterePrecedenti = assenzeCorsoPrecedente.filter(
      (d) => d.peso === 1.0,
    ).length;
    const assenzeMezzeGiornatePrecedenti = assenzeCorsoPrecedente.filter(
      (d) => d.peso === 0.5,
    ).length;

    // Calcola recuperi CONFERMATI (somma dei pesi) - conta solo quelli con status RECUPERATO
    const recuperiCompletati = this.state.dettagliPresenze.filter((d) =>
      d.status.includes("RECUPERATO"),
    );

    console.log("[PDF] 🔍 DEBUG RECUPERI COMPLETATI:");
    recuperiCompletati.forEach((r, idx) => {
      console.log(
        `  ${idx + 1}. Data: ${r.data}, Sessione: ${r.id_sessione}, Peso: ${
          r.peso
        }, Status: ${r.status}, Argomento: ${r.argomento?.substring(0, 50)}`,
      );
    });

    const recuperiPeso = recuperiCompletati.reduce((sum, d) => sum + d.peso, 0);

    console.log(
      `[PDF] 🔍 TOTALE RECUPERI PESO: ${recuperiPeso} (da ${recuperiCompletati.length} righe)`,
    );

    // Conta recuperi mezze giornate e giornate intere
    const recuperiInteri = this.state.dettagliPresenze.filter(
      (d) => d.status.includes("RECUPERATO") && d.peso === 1.0,
    ).length;
    const recuperiMezzeGiornate = this.state.dettagliPresenze.filter(
      (d) => d.status.includes("RECUPERATO") && d.peso === 0.5,
    ).length;

    // Calcola richieste di recupero in corso (IN RICHIESTA + PROGRAMMATO)
    const richiesteInCorso = this.state.dettagliPresenze.filter(
      (d) =>
        d.status.includes("IN RICHIESTA") || d.status.includes("PROGRAMMATO"),
    );

    console.log("[PDF] 🔍 DEBUG RICHIESTE IN CORSO:");
    richiesteInCorso.forEach((r, idx) => {
      console.log(
        `  ${idx + 1}. Data: ${r.data}, Sessione: ${r.id_sessione}, Peso: ${
          r.peso
        }, Status: ${r.status}, Argomento: ${r.argomento?.substring(0, 50)}`,
      );
    });

    const richiestePeso = richiesteInCorso.reduce((sum, d) => sum + d.peso, 0);
    const richiesteIntere = richiesteInCorso.filter((d) => d.peso === 1.0)
      .length;
    const richiesteMezzeGiornate = richiesteInCorso.filter(
      (d) => d.peso === 0.5,
    ).length;

    console.log(
      `[PDF] 🔍 TOTALE RICHIESTE IN CORSO: ${richiestePeso} (da ${richiesteInCorso.length} righe)`,
    );

    // ✅ FIX: Le assenze effettive sono: totale assenze - recuperi completati
    // Le richieste in corso NON devono essere sottratte dalle assenze effettive
    const assenzeEffettive = Math.max(0, assenzeTotaliPeso - recuperiPeso);

    console.log(
      `[PDF] 🔍 CALCOLO FINALE: ${assenzeTotaliPeso} (assenze) - ${recuperiPeso} (recuperi) = ${assenzeEffettive} (effettive) | Richieste in corso: ${richiestePeso} (mostrate separatamente)`,
    );

    // Calcola la descrizione dettagliata per le assenze effettive
    // Conta solo le assenze NON recuperate e SENZA richiesta in corso (né IN RICHIESTA né PROGRAMMATO)
    const assenzeNonRecuperate = this.state.dettagliPresenze.filter(
      (d) =>
        d.status.includes("ASSENTE") &&
        !d.status.includes("RECUPERATO") &&
        !d.status.includes("IN RICHIESTA") &&
        !d.status.includes("PROGRAMMATO"),
    );
    const assenzeEffettiveIntere = assenzeNonRecuperate.filter(
      (d) => d.peso === 1.0,
    ).length;
    const assenzeEffettiveMezze = assenzeNonRecuperate.filter(
      (d) => d.peso === 0.5,
    ).length;

    // Crea la descrizione: (1 x 2) oppure (0.5 x 4) oppure (1 x 1 + 0.5 x 2)
    let assenzeEffettiveDettaglio = "";
    if (assenzeEffettiveIntere > 0 && assenzeEffettiveMezze > 0) {
      assenzeEffettiveDettaglio = `(1 x ${assenzeEffettiveIntere} + 0.5 x ${assenzeEffettiveMezze})`;
    } else if (assenzeEffettiveIntere > 0) {
      assenzeEffettiveDettaglio = `(1 x ${assenzeEffettiveIntere})`;
    } else if (assenzeEffettiveMezze > 0) {
      assenzeEffettiveDettaglio = `(0.5 x ${assenzeEffettiveMezze})`;
    }

    console.log(
      `[PDF] 🔍 DETTAGLIO ASSENZE EFFETTIVE: ${assenzeEffettiveDettaglio}`,
    );

    return (
      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Document>
          {/* ✅ MODIFICA 2: Prima pagina - solo header e statistiche */}
          <Page size="A4" style={styles.page}>
            {/* Header */}
            <View style={styles.header}>
              <Text style={styles.mainTitle}>RIEPILOGO PRESENZE</Text>
              <Text style={styles.subtitle}>Studente: {studenteNome}</Text>
              <Text style={styles.subtitle}>Corso: {corsoNome}</Text>
              <Text style={styles.subtitle}>
                Anno Accademico: {this.corso?.anno_accademico || ""}
              </Text>
            </View>

            {/* Statistiche */}
            <View style={styles.statsContainer}>
              <Text style={styles.statsTitle}>RIEPILOGO STATISTICHE</Text>
              <View style={styles.statsRow}>
                <Text style={styles.statsLabel}>Totale Lezioni:</Text>
                <Text style={styles.statsValue}>{totaleLezrioni}</Text>
              </View>

              {/* Sezione Assenze con dettaglio mezze giornate */}
              <View style={styles.statsSeparator} />
              <Text style={styles.statsSectionTitle}>
                ASSENZE CORSO CORRENTE
              </Text>

              <View style={styles.statsRow}>
                <Text style={styles.statsLabel}>• Giornate Intere:</Text>
                <Text style={styles.statsValue}>
                  {assenzeIntere > 0
                    ? `${assenzeIntere} (1 x ${assenzeIntere})`
                    : assenzeIntere}
                </Text>
              </View>
              <View style={styles.statsRow}>
                <Text style={styles.statsLabel}>
                  • Sessioni (Prima/Seconda metà):
                </Text>
                <Text style={styles.statsValue}>
                  {assenzeMezzeGiornate > 0
                    ? `${assenzeMezzeGiornate} (0.5 x ${assenzeMezzeGiornate})`
                    : assenzeMezzeGiornate}
                </Text>
              </View>
              <View style={styles.statsRow}>
                <Text style={[styles.statsLabel, styles.bold]}>
                  Subtotale Corso Corrente (lezioni):
                </Text>
                <Text style={[styles.statsValue, styles.bold]}>
                  {assenzeCorsoCorrentePeso.toFixed(1)}
                </Text>
              </View>

              {/* Assenze da corsi precedenti */}
              {assenzeCorsoPrecedentePeso > 0 && (
                <>
                  <View style={styles.statsSeparator} />
                  <Text style={styles.statsSectionTitle}>
                    ASSENZE DA CORSI PRECEDENTI
                  </Text>

                  <View style={styles.statsRow}>
                    <Text style={styles.statsLabel}>• Giornate Intere:</Text>
                    <Text style={styles.statsValue}>
                      {assenzeInterePrecedenti > 0
                        ? `${assenzeInterePrecedenti} (1 x ${assenzeInterePrecedenti})`
                        : assenzeInterePrecedenti}
                    </Text>
                  </View>
                  <View style={styles.statsRow}>
                    <Text style={styles.statsLabel}>
                      • Sessioni (Prima/Seconda metà):
                    </Text>
                    <Text style={styles.statsValue}>
                      {assenzeMezzeGiornatePrecedenti > 0
                        ? `${assenzeMezzeGiornatePrecedenti} (0.5 x ${assenzeMezzeGiornatePrecedenti})`
                        : assenzeMezzeGiornatePrecedenti}
                    </Text>
                  </View>
                  <View style={styles.statsRow}>
                    <Text style={[styles.statsLabel, styles.bold]}>
                      Subtotale Corsi Precedenti (lezioni):
                    </Text>
                    <Text
                      style={[
                        styles.statsValue,
                        styles.bold,
                        { color: "#FF9800" },
                      ]}
                    >
                      {assenzeCorsoPrecedentePeso.toFixed(1)}
                    </Text>
                  </View>
                </>
              )}

              {/* Totale generale assenze */}
              <View style={styles.statsSeparator} />
              <View style={styles.statsRow}>
                <Text style={[styles.statsLabel, styles.bold]}>
                  TOTALE ASSENZE (lezioni):
                </Text>
                <Text style={[styles.statsValue, styles.bold]}>
                  {assenzeTotaliPeso.toFixed(1)}
                </Text>
              </View>

              {/* Sezione Recuperi con dettaglio */}
              <View style={styles.statsSeparator} />
              <Text style={styles.statsSectionTitle}>RECUPERI COMPLETATI</Text>

              <View style={styles.statsRow}>
                <Text style={styles.statsLabel}>• Giornate Intere:</Text>
                <Text style={styles.statsValue}>{recuperiInteri}</Text>
              </View>
              <View style={styles.statsRow}>
                <Text style={styles.statsLabel}>
                  • Sessioni (Prima/Seconda metà):
                </Text>
                <Text style={styles.statsValue}>{recuperiMezzeGiornate}</Text>
              </View>
              <View style={styles.statsRow}>
                <Text style={[styles.statsLabel, styles.bold]}>
                  Totale Recuperi (lezioni):
                </Text>
                <Text style={[styles.statsValue, styles.bold]}>
                  {recuperiPeso.toFixed(1)}{" "}
                  {recuperiInteri > 0 && recuperiMezzeGiornate > 0
                    ? `(1 x ${recuperiInteri} + 0.5 x ${recuperiMezzeGiornate})`
                    : recuperiInteri > 0
                    ? `(1 x ${recuperiInteri})`
                    : recuperiMezzeGiornate > 0
                    ? `(0.5 x ${recuperiMezzeGiornate})`
                    : ""}
                </Text>
              </View>

              {/* Sezione Richieste di Recupero in Corso */}
              {richiestePeso > 0 && (
                <>
                  <View style={styles.statsSeparator} />
                  <Text style={styles.statsSectionTitle}>
                    RICHIESTE RECUPERO IN CORSO
                  </Text>

                  <View style={styles.statsRow}>
                    <Text style={styles.statsLabel}>• Giornate Intere:</Text>
                    <Text style={styles.statsValue}>{richiesteIntere}</Text>
                  </View>
                  <View style={styles.statsRow}>
                    <Text style={styles.statsLabel}>
                      • Sessioni (Prima/Seconda metà):
                    </Text>
                    <Text style={styles.statsValue}>
                      {richiesteMezzeGiornate}
                    </Text>
                  </View>
                  <View style={styles.statsRow}>
                    <Text style={[styles.statsLabel, styles.bold]}>
                      Totale Richieste (lezioni):
                    </Text>
                    <Text
                      style={[
                        styles.statsValue,
                        styles.bold,
                        { color: "#FF9800" },
                      ]}
                    >
                      {richiestePeso.toFixed(1)}{" "}
                      {richiesteIntere > 0 && richiesteMezzeGiornate > 0
                        ? `(1 x ${richiesteIntere} + 0.5 x ${richiesteMezzeGiornate})`
                        : richiesteIntere > 0
                        ? `(1 x ${richiesteIntere})`
                        : richiesteMezzeGiornate > 0
                        ? `(0.5 x ${richiesteMezzeGiornate})`
                        : ""}
                    </Text>
                  </View>
                </>
              )}

              {/* Totali finali */}
              <View style={styles.statsSeparator} />
              <View style={styles.statsRow}>
                <Text style={[styles.statsLabel, styles.highlight]}>
                  Assenze Effettive:
                </Text>
                <Text style={[styles.statsValue, styles.highlight]}>
                  {assenzeEffettive.toFixed(1)} {assenzeEffettiveDettaglio}
                </Text>
              </View>
              <View style={styles.statsRow}>
                <Text style={[styles.statsLabel, styles.highlight]}>
                  Percentuale Frequenza:
                </Text>
                <Text style={[styles.statsValue, styles.highlight]}>
                  {totaleLezrioni > 0
                    ? (
                        ((presenzePeso + recuperiPeso) / totaleLezrioni) *
                        100
                      ).toFixed(1)
                    : 0}
                  %
                </Text>
              </View>
            </View>

            {/* Footer prima pagina */}
            <View style={styles.footer}>
              <Text style={styles.footerText}>
                Documento generato il {moment().format("DD/MM/YYYY HH:mm")}
              </Text>
            </View>
          </Page>

          {/* ✅ MODIFICA 2: Seconda pagina - tabella dettaglio */}
          <Page size="A4" style={styles.page}>
            {/* Header seconda pagina */}
            <View style={styles.header}>
              <Text style={styles.mainTitle}>DETTAGLIO ASSENZE E RECUPERI</Text>
              <Text style={styles.subtitle}>Studente: {studenteNome}</Text>
            </View>

            {/* Tabella dettagli */}
            <View style={styles.tableContainer}>
              <Text style={styles.tableTitle}>
                DETTAGLIO PRESENZE PER LEZIONE
              </Text>

              {/* Header tabella */}
              <View style={styles.tableHeader}>
                <Text style={[styles.tableCell, styles.dateColumn]}>Data</Text>
                <Text style={[styles.tableCell, styles.argumentColumn]}>
                  Argomento
                </Text>
                <Text style={[styles.tableCell, styles.statusColumn]}>
                  Stato
                </Text>
                <Text style={[styles.tableCell, styles.typeColumn]}>Tipo</Text>
                <Text style={[styles.tableCell, styles.recoveryColumn]}>
                  Recupero
                </Text>
              </View>

              {/* Righe tabella */}
              {this.state.dettagliPresenze.map((dettaglio, index) => {
                const sessioneLabel = this.getSessioneLabel(
                  dettaglio.id_sessione,
                );
                const recuperoLabel = dettaglio.recupero
                  ? this.getSessioneLabel(dettaglio.recupero.id_sessione)
                  : null;

                // Stile per assenze da corso precedente
                const rowStyle = dettaglio.isDaCorsoPrecedente
                  ? { ...styles.tableRow, backgroundColor: "#FFF3E0" }
                  : styles.tableRow;

                // Determina il colore dello status in base al tipo
                const statusStyle = dettaglio.status.includes("RECUPERATO")
                  ? styles.recovered // Verde per recuperate
                  : dettaglio.status.includes("PROGRAMMATO")
                  ? styles.programmed // Blu per programmato
                  : dettaglio.status.includes("IN RICHIESTA")
                  ? styles.inRequest // Arancione per richieste in corso
                  : dettaglio.status.includes("ASSENTE")
                  ? styles.absent // Rosso per assenti
                  : styles.present; // Verde per presenti

                return (
                  <View key={index} style={rowStyle}>
                    <Text style={[styles.tableCell, styles.dateColumn]}>
                      {this.formatDate(dettaglio.data)}
                    </Text>
                    <Text style={[styles.tableCell, styles.argumentColumn]}>
                      {dettaglio.isDaCorsoPrecedente && ""}
                      {dettaglio.argomento}
                    </Text>
                    <Text
                      style={[
                        styles.tableCell,
                        styles.statusColumn,
                        statusStyle,
                      ]}
                    >
                      {dettaglio.status}
                    </Text>
                    <Text style={[styles.tableCell, styles.typeColumn]}>
                      {dettaglio.status.includes("ASSENTE") ||
                      dettaglio.status.includes("RECUPERATO")
                        ? sessioneLabel || "Intera"
                        : "-"}
                    </Text>
                    <Text style={[styles.tableCell, styles.recoveryColumn]}>
                      {dettaglio.status.includes("RECUPERATO") &&
                      dettaglio.data_recupero
                        ? this.formatDate(dettaglio.data_recupero)
                        : dettaglio.recupero && dettaglio.recupero.confermato
                        ? this.formatDate(dettaglio.recupero.data)
                        : dettaglio.status.includes("PROGRAMMATO") &&
                          dettaglio.data_proposta
                        ? `${this.formatDate(
                            dettaglio.data_proposta,
                          )} (Programmato)`
                        : dettaglio.status.includes("PROGRAMMATO")
                        ? "Programmato"
                        : dettaglio.status.includes("IN RICHIESTA")
                        ? `In attesa ${
                            dettaglio.data_richiesta
                              ? `(${this.formatDate(dettaglio.data_richiesta)})`
                              : ""
                          }`
                        : dettaglio.status.includes("ASSENTE") &&
                          dettaglio.id_recupero
                        ? "Richiesta"
                        : "-"}
                    </Text>
                  </View>
                );
              })}
            </View>

            {/* Footer seconda pagina */}
            <View style={styles.footer}>
              <Text style={styles.footerText}>
                Pagina 2 - Documento generato il{" "}
                {moment().format("DD/MM/YYYY HH:mm")}
              </Text>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    );
  }
}

const styles = StyleSheet.create({
  page: {
    fontSize: 10,
    backgroundColor: "#ffffff",
    padding: 20,
  },
  header: {
    marginBottom: 20,
    textAlign: "center",
    borderBottom: "2 solid #000",
    paddingBottom: 10,
  },
  mainTitle: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 12,
    marginBottom: 5,
  },
  statsContainer: {
    marginBottom: 20,
    padding: 10,
    border: "1 solid #ccc",
    backgroundColor: "#f9f9f9",
  },
  statsTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10,
    textAlign: "center",
  },
  statsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  statsLabel: {
    fontSize: 10,
    fontWeight: "bold",
  },
  statsValue: {
    fontSize: 10,
  },
  statsSeparator: {
    marginTop: 8,
    marginBottom: 5,
    borderBottom: "1 solid #ddd",
  },
  statsSectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#333",
  },
  bold: {
    fontWeight: "extrabold",
  },
  highlight: {
    fontWeight: "bold",
    color: "#e61f29",
  },
  tableContainer: {
    marginBottom: 20,
  },
  tableTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10,
    textAlign: "center",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#e61f29",
    border: "1 solid #000",
  },
  tableRow: {
    flexDirection: "row",
    border: "1 solid #ccc",
    borderTop: "none",
  },
  tableCell: {
    padding: 5,
    fontSize: 9,
    borderRight: "1 solid #ccc",
  },
  dateColumn: {
    width: "12%",
  },
  argumentColumn: {
    width: "33%",
  },
  statusColumn: {
    width: "12%",
    textAlign: "center",
    fontSize: 7, // Testo più piccolo per evitare a capo
  },
  typeColumn: {
    width: "10%",
    textAlign: "center",
    fontSize: 7, // Testo più piccolo come la colonna stato
  },
  recoveryColumn: {
    width: "33%",
    fontSize: 8,
  },
  present: {
    color: "#008000",
    fontWeight: "bold",
  },
  absent: {
    color: "#e61f29",
    fontWeight: "bold",
  },
  recovered: {
    color: "#4CAF50",
    fontWeight: "bold",
  },
  inRequest: {
    color: "#FF9800",
    fontWeight: "bold",
  },
  programmed: {
    color: "#2196F3",
    fontWeight: "bold",
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
    textAlign: "center",
    borderTop: "1 solid #ccc",
    paddingTop: 10,
  },
  footerText: {
    fontSize: 8,
    color: "#666",
  },
});
